import React from 'react';
import { Button, Tooltip } from 'antd';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeProvider';

/** Light/dark toggle for the admin header. */
export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <Button
        type="text"
        shape="circle"
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        onClick={toggleTheme}
        icon={isDark ? <Sun size={18} /> : <Moon size={18} />}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
